<template>
    <div>
        <div class="demo-upload-list" v-for="(item, index) in uploadList">
            <template>
                <img :src="item" style="width:80px;height:80px;object-fit:contain"/>
                <div class="demo-upload-list-cover">
                    <Icon type="ios-brush-outline" @click="handleEdit(item, index)"></Icon>
                    <Icon type="ios-trash-outline" @click="handleRemove(item)"></Icon>
                </div>
            </template>
        </div>
        <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList"
            :format="['jpg', 'jpeg', 'png', 'webp']" :max-size="2048" :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" type="drag" action=""
            style="display: inline-block;width:80px;">
            <div style="width: 80px;height:80px;line-height: 80px;">
                <Icon type="ios-camera" size="20"></Icon>
            </div>
            <Spin fix v-show="uploading"></Spin>
        </Upload>
    </div>
</template>
<script>
import {getUpToken} from "@/request/api"
import axios from 'axios';
export default {
    name: 'uploadImages',
    data() {
        return {
            defaultList: [],
            imgName: '',
            uploadList: [],
            uploading: false
        }
    },
    methods: {
        handleEdit(file, index) {
            this.$emit('edit', file, index)
        },
        handleRemove(file) {
            this.uploadList.splice(this.uploadList.indexOf(file), 1);
        },
        handleSuccess(res, file) {},
        handleFormatError(file) {
            this.$Notice.warning({
                title: 'The file format is incorrect',
                desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
            });
        },
        handleMaxSize(file) {
            this.$Notice.warning({
                title: 'Exceeding file size limit',
                desc: 'File  ' + file.name + ' is too large, no more than 2M.'
            });
        },
        handleBeforeUpload(file) {
            const check = this.uploadList.length <= 5;
            if (!check) {
                this.$Notice.warning({
                    title: 'Up to five pictures can be uploaded.'
                });
            } else {
                this.uploading = true
                this.uploadFile(file)
            }
            return false
        },
        // 上传七牛云
        uploadFile(file) {
            getUpToken().then(res => {
                let formData = new FormData()
                formData.append('token', res.data.data.uptoken)
                formData.append('file', file)
                axios.post('https://up-z2.qiniup.com', formData).then(res => {
                    let painting_url = 'https://qy-oss.yolanda.hk/' + res.data.key
                    this.uploadList.push(painting_url)
                    this.uploading = false
                })
            })
        },
    }
}
</script>
<style>
.demo-upload-list {
    display: inline-block;
    width: 80px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
}

.demo-upload-list img {
    width: 100%;
    height: 100%;
}

.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}

.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/upload_images.vue